import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massForceDeleteProjects } from '../../api/apiProjects';
import toast from 'react-hot-toast';

export const useMassForceDeleteProjects = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: massForceDeleteProjects,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['projects'] });
            toast.success(data.message || 'Projects permanently deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to permanently delete projects';
            toast.error(errorMessage);
        },
    });
};